import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NGXLogger } from 'ngx-logger';

import { MerchantRequestService } from '@shared/services/merchant-request.service';

import { ModalButtonResponseEnum } from '../../../shared/enum/modal-button-response.enum';
import { ConfirmModalComponent } from '../../../shared/layouts/modals/confirm-modal/confirm-modal.component';
import { UserDto } from '../../../shared/models';
import { AuthGuardService } from '../../../shared/services';
import { MasterService } from '../../../shared/services/master.service';
import { RoleService } from '../../../shared/services/role.service';
import { StoreRequestService } from '../../../shared/services/store-request.service';
import { UserCreateRequestAction } from '../../../shared/store/actions/user-info.action';
import { selectUsersListCriteria } from '../../../shared/store/selectors/user-selector';
import { AppStates } from '../../../shared/store/state/app.states';
import { RoleAllRequestAction } from '../../roles/stores/role/role.actions';
import { selectRoleAllList } from '../../roles/stores/role/role.selectors';
import { StoreAuthorityService } from '../services/store-authority.service';
import { UserEditComponent } from '../user-edit/user-edit.component';

@Component({
  selector: 'app-user-create',
  templateUrl: '../user-edit/user-edit.component.html',
  styleUrls: ['../user-edit/user-edit.component.scss']
})
export class UserCreateComponent extends UserEditComponent implements OnInit, OnDestroy {
  constructor(
    protected readonly store: Store<AppStates>,
    protected readonly translate: TranslateService,
    protected readonly fb: UntypedFormBuilder,
    protected readonly logger: NGXLogger,
    protected readonly modalService: BsModalService,
    protected storeRequestService: StoreRequestService,
    protected storeAuthorityService: StoreAuthorityService,
    protected masterService: MasterService,
    protected roleService: RoleService,
    protected authGuardService: AuthGuardService,
    protected merchantRequestService: MerchantRequestService
  ) {
    super(
      store,
      translate,
      fb,
      logger,
      modalService,
      storeRequestService,
      storeAuthorityService,
      masterService,
      roleService,
      authGuardService,
      merchantRequestService
    );
    this.hasStoreAuthority = false;
  }

  ngOnInit() {
    this.initControl();
    this.initData();
    this.initState();
    this.loadMerchant('');
  }

  initData() {
    this.loadDepartments();

    this.store.dispatch(new RoleAllRequestAction());
    this.localStore.pipe(select(selectRoleAllList)).subscribe(roles => {
      if (roles && roles.length > 0) {
        this.roleList = roles.filter(v => this.roleStoreOwner.indexOf(v.code) === -1);
        this.updateRoleOptions();
      }
    });
    this.localStore
      .pipe(select(selectUsersListCriteria))
      .subscribe(criteriaObject => (this.criteriaObject = criteriaObject));
  }

  sendToSubmit(data: UserDto) {
    const confirmModalRef = this.modalService.show(ConfirmModalComponent, {
      initialState: {
        title: 'Confirm',
        message: 'Are you sure you want to submit?'
      }
    });

    confirmModalRef.content.action
      .pipe(untilComponentDestroyed(this))
      .subscribe((result: ModalButtonResponseEnum) => {
        if (result === ModalButtonResponseEnum.OK) {
          this.isSendToSubmit = true;
          this.store.dispatch(new UserCreateRequestAction(data));
        }
      });
  }

  prepareData(): UserDto {
    const rawData = this.userForm.getRawValue();

    const dataRequest = {
      ...rawData,
      ...this.prepareUserRequest(rawData),
      tenant: {
        merchant: rawData.merchant.merchant
      }
    } as UserDto;

    this.removeFormOnlyFields(dataRequest);
    return dataRequest;
  }
}
